export class OrganizationDepartmentFilterRequest {
    keywords: string;
    orderBy: string;
    asc: boolean;
    pageIndex: number;

    constructor() {
        this.pageIndex = 0;
        this.asc = false;
        this.orderBy = "";
        this.keywords = "";
    }
}

export class OrganizationDepartmentResponse {
    id = 0;
    name = "";
}

export interface GetOrganizationDepartmentsResponse {
    total: number;
    totalFilter: number;
    hasNext: boolean;
    rows: OrganizationDepartmentResponse[];
}

export class CreateOrganizationDepartmentRequest {
    name = "";
}

export class EditOrganizationDepartmentRequest {
    id = 0;
    name = "";
}

export class EmployeeGroupFilterRequest {
    keywords: string;
    orderBy: string;
    asc: boolean;
    pageIndex: number;

    constructor() {
        this.pageIndex = 0;
        this.asc = false;
        this.orderBy = "";
        this.keywords = "";
    }
}

export class EmployeeGroupsResponse {
    id = 0;
    name = "";
}

export interface GetEmployeeGroupsResponse {
    total: number;
    totalFilter: number;
    hasNext: boolean;
    rows: OrganizationDepartmentResponse[];
}

export class EditEmployeeGroupRequest {
    id = 0;
    name = "";
}
